type RuntimeConfig = {
  korapay_key?: string;
  success_redirect_path?: string;
};

export const get_runtime_config = (): RuntimeConfig => {
  const host_config = (window as any).web_checkout_config || {};

  return {
    korapay_key: host_config.korapay_key,
    success_redirect_path: host_config.success_redirect_path,
  };
};
